import { SubdistrictCreatePage } from "@/features/geolocation/page/SubdistrictCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/subdistrict/create")({
  component: SubdistrictCreatePage,
});
